import React from 'react';

export function FacebookIcon(
  props: React.ReactComponentElement<'svg'>['props']
) {
  return (
    <svg
      height="16"
      viewBox="0 0 320 512"
      width="10"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M80 299.3V512h116V299.3h86.5l18-97.8H196v-34.6c0-51.7 20.3-71.5 72.7-71.5 16.3 0 29.4.4 37 1.2V7.9C291.4 4 256.4 0 236.2 0 129.3 0 80 50.5 80 159.4v42.1H14v97.8h66z" />
    </svg>
  );
}
